import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { Body2 } from 'ui/theme';
import { useModalContext } from 'utils/contexts/modal';
import { CopyableInputField } from './CopyableInputField';
import { ModalState } from './ApiKeyModal.constants';

const DEFAULT_TEXT = {
  HEADER: 'Copy your new API key',
  DESCRIPTION:
    'Copy the API key and store it in a secure location. After you close this window, Iterable can only display the key’s last 8 characters. If you lose it, you’ll have to create a new one.',
};

const WITH_JWT_TEXT = {
  HEADER: 'Copy your new API key and JWT secret',
  DESCRIPTION:
    "Copy and store the API key and JWT secret in a secure location—after you close this window, Iterable can't display them again. If you lose either one, you'll need to create a new API key.",
};

export const ViewApiKeyModal = () => {
  const { hideModal, modalState } = useModalContext();
  const { createResponsePayload } = modalState as ModalState;

  if (!createResponsePayload) return null;

  const hasJwtSecret = Boolean(createResponsePayload.secret);
  const text = hasJwtSecret ? WITH_JWT_TEXT : DEFAULT_TEXT;

  return (
    <Modal
      id="view-api-key-modal"
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>{text.HEADER}</ModalHeader>
      <ModalBody>
        <Body2>{text.DESCRIPTION}</Body2>
        <CopyableInputField name="api-key" labelText="API key" value={createResponsePayload.key} />
        {createResponsePayload.secret && (
          <CopyableInputField
            name="jwt-secret"
            labelText="JWT secret"
            value={createResponsePayload.secret}
          />
        )}
      </ModalBody>
      <ModalFooter hasCancel={false}>
        <SecondaryButton onClick={hideModal} size={BUTTON_SIZES.LARGE}>
          Close
        </SecondaryButton>
      </ModalFooter>
    </Modal>
  );
};
